<template>
    <div id="system_site">
        <el-card class="box-card">
            <el-form ref="form" :model="form"
                     :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'300px'"
                     size="small">
                <el-form-item :label="'一级分销获得'+this.$store.state.name"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-input v-model="form.flevel"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                </el-form-item>
                <el-form-item :label="'二级分销获得'+this.$store.state.name"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                    <el-input v-model="form.glevel"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>

    export default {
        name: "system_site",
        data() {
            return {
                form: {
                    flevel: '',
                    glevel: ''
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            onSubmit() {
                this.$axios.post('admin/config/distribution_set', {config: this.form}).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                });
            },
            getData() {
                this.$axios.post('admin/config/distribution', '').then((res) => {
                    this.form = res.data;
                });
            },

        }
    }
</script>

<style scoped lang="scss">

</style>